module.exports = __webpack_public_path__ + "static/Aditya-88842a01bb59ba864cd8bd5db0bea807.jpg";